export default {
	headerHeight: 0,
	scrollOffset: 20,
};
